import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=27d84f60&scoped=true&"
import script from "./SettingsIcon.vue?vue&type=script&lang=ts&"
export * from "./SettingsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d84f60",
  null
  
)

export default component.exports